import React from 'react'
import DataNotFound from '../../../../component/ui/loader/data-not-found'

const FleetMySpaceCarDetail = () => {
  return (
    <div className='w-full h-full flex items-center justify-center'>
      <DataNotFound content={"No Working This Page"} />
    </div>
  )
}

export default FleetMySpaceCarDetail
